import { render, staticRenderFns } from "./registeredProduct.vue?vue&type=template&id=9aca4986&"
import script from "./registeredProduct.vue?vue&type=script&lang=js&"
export * from "./registeredProduct.vue?vue&type=script&lang=js&"
import style0 from "./registeredProduct.vue?vue&type=style&index=0&id=9aca4986&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports